import DropZoneInput from '../Common/DropZoneInput';

const DropZoneInputWrapper = objProps => {
  return <DropZoneInput {...objProps.field} {...objProps} />;
};

export default DropZoneInputWrapper;
